export default __webpack_public_path__ + "static/media/nextArrow.874ae6e1.svg";